import { render, staticRenderFns } from "./VSelectAcademicDegree.vue?vue&type=template&id=7f09aca4&"
import script from "./VSelectAcademicDegree.vue?vue&type=script&lang=js&"
export * from "./VSelectAcademicDegree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f09aca4')) {
      api.createRecord('7f09aca4', component.options)
    } else {
      api.reload('7f09aca4', component.options)
    }
    module.hot.accept("./VSelectAcademicDegree.vue?vue&type=template&id=7f09aca4&", function () {
      api.rerender('7f09aca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectAcademicDegree.vue"
export default component.exports